import { defineStore } from "pinia";
import { ref } from "vue";

export interface Toast {
  id: string;
  level: "info" | "success" | "error";
  text: string;
}

const DEFAULT_TTL_MS = 5_000;

export const useToastsStore = defineStore("toasts", () => {
  const list = ref<Toast[]>([]);

  function push(level: Toast["level"], text: string, ttlMs = DEFAULT_TTL_MS): void {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    list.value = [...list.value, { id, level, text }];
    if (ttlMs > 0) {
      setTimeout(() => dismiss(id), ttlMs);
    }
  }

  function success(text: string): void {
    push("success", text);
  }
  function error(text: string): void {
    // Errors stick longer so the user has time to read them before
    // they disappear.
    push("error", text, 8_000);
  }
  function info(text: string): void {
    push("info", text);
  }

  function dismiss(id: string): void {
    list.value = list.value.filter((t) => t.id !== id);
  }

  return { list, push, success, error, info, dismiss };
});
